export default "__VITE_ASSET__D88k5LAO__"